import { useEffect, useState } from 'react'

const useNetworkStatus = (): 'wifi' | 'cellular' | 'none' | 'unknown' => {
  const [status, setStatus] = useState<'wifi' | 'cellular' | 'none' | 'unknown'>('wifi')

  useEffect(() => {
    const updateOnlineStatus = () => {
      // For web, we can only detect online/offline, not specific connection type
      // Default to 'wifi' when online, 'none' when offline
      setStatus(navigator.onLine ? 'wifi' : 'none')
    }

    updateOnlineStatus()

    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)

    return () => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
    }
  }, [])

  return status
}

export default useNetworkStatus
